import * as _ from "lodash";
import {ESRecord} from "../lib/ESRecord";
import {utils} from "js-data";


export  interface IRecordChangeFunction {
  (record: any, propertyName: string, propertyValue: any, options: any): void
}

export class SimpleRecord {

  constructor(){
    utils.eventify(this, undefined,undefined,true)
  }

  setupOnChangeEvents( arrProperties: string[], changeFunction: IRecordChangeFunction, opts?: any) {
    const self = this

    _.forEach(arrProperties, (key) => {
      //@ts-ignore
      self.on('change:' + key, function(record: ESRecord, newValue: any) {
        changeFunction(record, this.propertyName, newValue, this.options)
      }, {propertyName: key, options: opts})
    })

  }

  protected notify(fieldname: string, value: any){
    const self = this
    //@ts-ignore
    self.emit('change:' + fieldname, this, value)

  }

  static eventifyObject(anObject: any){
    utils.eventify(anObject, undefined, undefined)

    anObject.notify = function(fieldname: string, value: any){
      const self = this
      //@ts-ignore
      self.emit('change:' + fieldname, this, value)
    }

    anObject.setupOnChangeEvents = function( arrProperties: string[], changeFunction: IRecordChangeFunction, opts?: any) {
      const self = this

      _.forEach(arrProperties, (key) => {
        //@ts-ignore
        self.on('change:' + key, function(record: ESRecord, newValue: any) {
          changeFunction(record, this.propertyName, newValue, this.options)
        }, {propertyName: key, options: opts})
      })

    }

  }

}


